export default __webpack_public_path__ + "static/media/close-gray.e5de827c.svg";